import React from 'react';
import { DeprecatedDynamicSkeleton } from '@components/main-components/skeleton/Skeleton';
import { CollectorAndReleaseDetails, Row } from './shared';

export const ArtistRowSkeleton = () => {
  return (
    <Row>
      <DeprecatedDynamicSkeleton width={40} height={40} borderRadius={8} />
      <CollectorAndReleaseDetails>
        <DeprecatedDynamicSkeleton width={100} height={20} borderRadius={8} />
      </CollectorAndReleaseDetails>
    </Row>
  );
};
